import React, { useState, useEffect } from 'react';
import JobCard from './components/JobCard';
import JobModal from './components/JobModal';
import JobFilter from './components/JobFilter';
import Loader from './components/Loader';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import './App.css';
import smallLogo from './assets/hr_small_logo.png';
import bigLogo from './assets/hr_big_logo.png';
import nprBigLogo from './assets/npr_hr_med_log .png';

function App() {
  const [jobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [filterCategory, setFilterCategory] = useState('כלל המשרות');
  const [filterLocation, setFilterLocation] = useState('כלל המיקומים');
  const [openJobId, setOpenJobId] = useState(null);
  const [logoSrc, setLogoSrc] = useState(bigLogo);
  const [loading, setLoading] = useState(true);

  const SHEET_URL =
    'https://script.google.com/macros/s/AKfycbzhXITkXYqMZ_Kd0KGeiJZ9kE91thCo4ZX1CGgZ9Sr48tfzaboi7HC7xZ__zedoixfFXA/exec';

  const toArray = (value) =>
    Array.isArray(value)
      ? value
      : typeof value === 'string'
      ? value.split(',').map((s) => s.trim())
      : [];

  const openModal = (job) => {
    setSelectedJob(job);
    setOpenJobId(job.id);
  };

  const closeModal = () => {
    setSelectedJob(null);
    setOpenJobId(null);
  };

  const handleCategoryChange = (category) => setFilterCategory(category);
  const handleLocationChange = (location) => setFilterLocation(location);

  const filteredJobs = jobList.filter((job) => {
    const categoryMatch =
      filterCategory === 'כלל המשרות' ||
      toArray(job.category).includes(filterCategory);
    const locationMatch =
      filterLocation === 'כלל המיקומים' ||
      toArray(job.location).includes(filterLocation);
    return categoryMatch && locationMatch;
  });

  const availableCategories = [
    'כלל המשרות',
    ...new Set(
      jobList
        .filter((job) => {
          const locMatch =
            filterLocation === 'כלל המיקומים' ||
            toArray(job.location).includes(filterLocation);
          return locMatch;
        })
        .flatMap((job) => toArray(job.category))
    ),
  ];

  const availableLocations = [
    'כלל המיקומים',
    ...new Set(
      jobList
        .filter((job) => {
          const catMatch =
            filterCategory === 'כלל המשרות' ||
            toArray(job.category).includes(filterCategory);
          return catMatch;
        })
        .flatMap((job) => toArray(job.location))
    ),
  ];

  useEffect(() => {
    const updateLogo = () => {
      if (window.innerWidth < 768) {
        setLogoSrc(smallLogo);
      } else {
        setLogoSrc(nprBigLogo);
      }
    };
    updateLogo();
    window.addEventListener('resize', updateLogo);
    return () => window.removeEventListener('resize', updateLogo);
  }, []);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(SHEET_URL);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Fetched data:', data);
        const jobsWithId = data.map((job, index) => ({
          ...job,
          id: index,
          category: toArray(job.category),
          location: toArray(job.location),
        }));
        setJobList(jobsWithId);
      } catch (error) {
        console.error('Error fetching jobs data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  return (
    <div className='App'>
      <header className='header-section'>
        <div className='header-wrapper'>
          <h1 className='header-title'>משרות פנויות ומגוון הזדמנויות</h1>
          <img alt='logo' src={logoSrc} className='app-logo' />
        </div>
      </header>
      <HeroSection />
      {/* <Loader /> */}
      <div className='main-container'>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className='job-filter-wrapper'>
              <JobFilter
                availableCategories={availableCategories}
                availableLocations={availableLocations}
                filterCategory={filterCategory}
                filterLocation={filterLocation}
                onCategoryChange={handleCategoryChange}
                onLocationChange={handleLocationChange}
              />
            </div>
            <div className='main-wrapper'>
              <div className='main-content'>
                <div className='job-grid'>
                  {filteredJobs.map((job, index) => (
                    <JobCard
                      key={index}
                      job={job}
                      openModal={openModal}
                      isOpen={openJobId === job.id}
                    />
                  ))}
                </div>
                {selectedJob && (
                  <JobModal job={selectedJob} closeModal={closeModal} />
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default App;

// import React, { useState, useEffect } from 'react';
// import { jobs } from './data/jobs';
// import JobCard from './components/JobCard';
// // import JobForm from './components/JobForm';
// import JobModal from './components/JobModal';
// import JobFilter from './components/JobFilter';
// import Footer from './components/Footer';
// import './App.css';
// import smallLogo from './assets/hr_small_logo.png';
// import bigLogo from './assets/hr_big_logo.png';
// import nprBigLogo from './assets/npr_hr_med_log .png';
// import HeroSection from './components/HeroSection';

// function App() {
//   const [jobList, setJobList] = useState(jobs);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [filterCategory, setFilterCategory] = useState('כלל המשרות');
//   const [filterLocation, setFilterLocation] = useState('כלל המיקומים');
//   const [openJobId, setOpenJobId] = useState(null);
//   const [logoSrc, setLogoSrc] = useState(bigLogo);

//   // Helper function to ensure value is an array
//   const toArray = (value) => (Array.isArray(value) ? value : [value]);

//   // Open and close modal
//   const openModal = (job) => {
//     setSelectedJob(job);
//     setOpenJobId(job.id);
//   };

//   const closeModal = () => {
//     setSelectedJob(null);
//     setOpenJobId(null);
//   };

//   // Filter handling
//   const handleCategoryChange = (category) => {
//     setFilterCategory(category);
//   };

//   const handleLocationChange = (location) => {
//     setFilterLocation(location);
//   };

//   // Job filtering
//   const filteredJobs = jobList.filter((job) => {
//     const categoryMatch =
//       filterCategory === 'כלל המשרות' ||
//       toArray(job.category).includes(filterCategory);
//     const locationMatch =
//       filterLocation === 'כלל המיקומים' ||
//       toArray(job.location).includes(filterLocation);
//     return categoryMatch && locationMatch;
//   });

//   // Compute available categories based on current location filter
//   const availableCategories = [
//     'כלל המשרות',
//     ...new Set(
//       jobList
//         .filter((job) => {
//           const locationMatch =
//             filterLocation === 'כלל המיקומים' ||
//             toArray(job.location).includes(filterLocation);
//           return locationMatch;
//         })
//         .flatMap((job) => toArray(job.category))
//     ),
//   ];

//   // Compute available locations based on current category filter
//   const availableLocations = [
//     'כלל המיקומים',
//     ...new Set(
//       jobList
//         .filter((job) => {
//           const categoryMatch =
//             filterCategory === 'כלל המשרות' ||
//             toArray(job.category).includes(filterCategory);
//           return categoryMatch;
//         })
//         .flatMap((job) => toArray(job.location))
//     ),
//   ];

//   // Update logo based on screen width
//   useEffect(() => {
//     const updateLogo = () => {
//       if (window.innerWidth < 768) {
//         setLogoSrc(smallLogo);
//       } else {
//         setLogoSrc(nprBigLogo);
//       }
//     };

//     // Set initial logo size
//     updateLogo();

//     // Add event listener for window resize
//     window.addEventListener('resize', updateLogo);

//     // Cleanup event listener on component unmount
//     return () => {
//       window.removeEventListener('resize', updateLogo);
//     };
//   }, []);

//   return (
//     <div className='App'>
//       <header className='header-section'>
//         <div className='header-wrapper'>
//           <h1 className='header-title'>משרות פנויות ומגוון הזדמנויות</h1>
//           <img alt='logo' src={logoSrc} className='app-logo' />
//         </div>
//       </header>
//       <HeroSection />
//       <div className='job-filter-wrapper'>
//         <JobFilter
//           availableCategories={availableCategories}
//           availableLocations={availableLocations}
//           filterCategory={filterCategory}
//           filterLocation={filterLocation}
//           onCategoryChange={handleCategoryChange}
//           onLocationChange={handleLocationChange}
//         />
//       </div>
//       <div className='main-wrapper'>
//         <div className='main-content'>
//           <div className='job-grid'>
//             {filteredJobs.map((job, index) => (
//               <JobCard
//                 key={index}
//                 job={job}
//                 openModal={openModal}
//                 isOpen={openJobId === job.id}
//               />
//             ))}
//           </div>
//           {selectedJob && (
//             <JobModal job={selectedJob} closeModal={closeModal} />
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default App;
